<template>
  <el-tooltip
    v-if="collapse && item.meta && !item.hidden"
    :content="item.meta ? item.meta.title : ''"
    placement="right"
  >
    <div
      :class="[
        'menu-item-fold',
        {
          'menu-item-fold--active': isActive,
        },
      ]"
      @click="handleCollapse"
    >
      <i :class="icon" style="font-size: 16px" />
    </div>
  </el-tooltip>
  <component
    :is="menuComponent"
    v-else-if="!collapse && item.meta && !item.hidden"
    :item="item"
    :full-path="fullPath"
    :route-children="routeChildren"
  >
    <template v-if="item.children && item.children.length">
      <ht-side-bar-item
        v-for="route in item.children"
        :key="route.alias || route.path"
        :full-path="handlePath(route.path)"
        :item="route"
      />
    </template>
  </component>
</template>

<script>
  import { isExternal } from '@/utils/validate'
  import { mapActions, mapGetters } from 'vuex'
  import path from 'path'

  export default {
    name: 'HtSideBarItem',
    props: {
      item: {
        type: Object,
        required: true,
      },
      fullPath: {
        type: String,
        default: '',
      },
    },
    data() {
      this.onlyOneChild = null
      return {}
    },
    computed: {
      ...mapGetters({
        collapse: 'settings/collapse',
      }),
      menuComponent() {
        if (
          this.handleChildren(this.item.children, this.item) &&
          (!this.routeChildren.children ||
            this.routeChildren.notShowChildren) &&
          !this.item.alwaysShow
        ) {
          return 'HtMenuItem'
        } else {
          return 'HtSubmenu'
        }
      },
      isActive() {
        return this.$route.matched.some((item) => item.path == this.item.path)
      },
      icon() {
        if (!this.item) return ''

        if (this.item.menuIcon) {
          return this.item.menuIcon
        }
        if (this.item.meta && this.item.meta.icon) {
          return this.item.meta.icon
        }
        return 'icon-monitor'
      },
    },
    methods: {
      ...mapActions({
        changeCollapse: 'settings/changeCollapse',
      }),
      handleCollapse() {
        this.changeCollapse()
      },
      handleChildren(children = [], parent) {
        if (children === null) children = []
        const showChildren = children.filter((item) => {
          if (item.hidden) {
            return false
          } else {
            this.routeChildren = item
            return true
          }
        })
        if (showChildren.length === 1) {
          return true
        }

        if (showChildren.length === 0) {
          this.routeChildren = {
            ...parent,
            path: '',
            notShowChildren: true,
          }
          return true
        }
        return false
      },
      handlePath(routePath) {
        if (isExternal(routePath)) {
          return routePath
        }
        if (isExternal(this.fullPath)) {
          return this.fullPath
        }
        return path.resolve(this.fullPath, routePath)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .menu-item-fold {
    width: 40px;
    height: 42px;
    margin: 0 5px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #5f737f;
    &:hover {
      color: #0560fd;
    }
    &--active {
      background: #eaf3ff;
      color: #0560fd;
    }
  }

  ::v-deep {
    .el-tag {
      float: right;
      height: 16px;
      padding-right: 4px;
      padding-left: 4px;
      margin-top: calc((#{$base-menu-item-height} - 16px) / 2);
      line-height: 16px;
      border: 0;
    }

    .el-icon-arrow-down {
      transform: rotate(90deg);
      color: var(--menuColor);
    }
  }
</style>
